import { useState, useEffect, } from 'react';
import { Button, Switch, Dialog } from '../../tailwindcomponents';
import { Typography, Input } from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import worldTools from '../../api/worldTools';
import { destinations } from '../../types/worldTools';

// Basic dictionary page using the dictionary component so easy to change style of all dictionary pages if needed.
function EditDestinations() {
  const [destinations, setDestinations] = useState(Array<destinations>());
  const [newPropertyInput, setNewPropertyInput] = useState('');
  const store = useSelector((state: RootState) => state);
  const currentUser = store.user.me;
  const [showActive, setShowActive] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [selectedDestination, setSelectedDestination] = useState<destinations | undefined>(undefined);

  useEffect(() => {
    refresh();
  }, []);

  const refresh = () => {
    worldTools.GetAllWorldTripLocations().then(res => {
      setDestinations(res.data);
    });
  }

  const onReasonEdit = (value: string) => {
    setDeleteReason(value);
  }
  const addDestination = (newProperty: string) => {
    worldTools.CreateWorldTripLocation(newProperty, currentUser.user_id).then(res => {
      refresh();
      setNewPropertyInput('');
    });
  }
  const deleteDestination = (destination: destinations) => {
    setSelectedDestination(destination);
    setDeleteDialogOpen(true);
  }
  const confirmDelete = () => {
    if (selectedDestination !== undefined) {
      selectedDestination.reason = deleteReason
      worldTools.RemoveWorldTripLocation(selectedDestination).then(res => {
        setSelectedDestination(undefined);
        refresh();
      });
    }
    setDeleteDialogOpen(false);
    setDeleteReason('');
  }

  return (
    <div>
      <div className="w-full flex flex-wrap justify-center" >
        <div className="w-1/2">
          <div className="flex flex-wrap w-full">
            <div className="w-1/3 lg:w-2/3"></div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="Active" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Switch
                checked={!showActive}
                onChange={() => setShowActive(!showActive)}
                color="secondary"
                name="checkedB"
              />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="Deleted" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
          </div>
          <div className="w-5/6">
            {
              destinations.filter(type => type.visible === showActive).map(row => (
                <Dictionary name={row.location} object={row} deleted={showActive === true ? false : true} description={showActive === true ? '' : row.reason} id={row.id} deleteProperty={(row: destinations) => deleteDestination(row)}></Dictionary>
              ))
            }
          </div>
        </div>
        <Dialog
          visible={deleteDialogOpen}
          max_width={"md"} title={"Are you sure you want to delete this?"}
          context={
            <div>
              <div className="flex justify-center w-full m-2 p-2">
                <Input
                  label_text={"Type a reason"} value={deleteReason} help_text=""
                  onTextChange={(value: string) => onReasonEdit(value)} type="text" width={50} multiline={false} />
              </div>

              <div className="flex justify-center m-2 p-2">
                <div className="p-2" >
                  <Button variant="contained" color="primary" onClick={() => confirmDelete()}>Confirm delete</Button>
                </div>
                <div className="p-2">
                  <Button variant="contained" color="secondary" onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                </div>
              </div>
            </div>
          }
          onClose={(status: any) => setDeleteDialogOpen(false)}
          strict={false}
          show_options={false}
        />
        <div className="w-5/12">
          <div className="w-full">
            <br />
            <Input
              multiline={false}
              label_text="New Property"
              help_text=""
              type="text"
              value={newPropertyInput}
              width={50}
              onTextChange={(value: string) => setNewPropertyInput(value)}
            />
          </div>
          <br />
          <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addDestination(newPropertyInput)} >
            Add Property
          </Button>
        </div>
      </div>
    </div>
  );
};
export default EditDestinations;
